import {
    SAVE_USER_BUILDER_LIST
} from './actionTypes';

export const saveUserBuilderList = payload => {
    return {
        type: SAVE_USER_BUILDER_LIST,
        payload
    }
}